import { ValidationError } from '@/shared/lib/validation-error';
import type { RecordSchema } from './record-schema';

export function validateRecord(schema: RecordSchema, data: Record<string, unknown>): Record<string, unknown> {
  const result = schema.safeParse(data);
  if (result.success) return result.data;
  throw new ValidationError(
    'Check the highlighted fields',
    result.error.issues.map((issue) => ({ path: issue.path, message: issue.message })),
  );
}
